import React from "react";
import "@/App.css";
import "@/i18n";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import { Privacy, Cookies, Terms } from "@/pages/LegalPages";
import ThankYou from "@/pages/ThankYou";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Navigate to="/it" replace />} />
          <Route path="/thank_you" element={<ThankYou />} />
          <Route path="/:lang" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="cookies" element={<Cookies />} />
            <Route path="terms" element={<Terms />} />
          </Route>
          <Route path="*" element={<Navigate to="/it" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
